module.exports = __webpack_public_path__ + "img/default_avatar.fcde9114.svg";